/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { NotificationBarStore } from './notification-bar-store';

export const NotificationBarStoreContext = createContext({} as NotificationBarStore);